<div *ngIf="!small; else smallHeader" class="page-header">
    <h4 class="title text-center">
      <span class="text-capitalize">{{headerText}}</span>
    </h4>
  </div>
  
  <ng-template #smallHeader>
  
    <div class="py-4 border-top">
  
      <h5 class="title">
        <span class="text-capitalize">{{headerText}}</span>
      </h5>
  
    </div>
  
  </ng-template>